export { default } from './course-element';
